import { render } from "./ExamImageTab.vue?vue&type=template&id=39a7fdac&scoped=true"
import script from "./ExamImageTab.js?vue&type=script&lang=js&external"
export * from "./ExamImageTab.js?vue&type=script&lang=js&external"

import "./ExamImageTab.vue?vue&type=style&index=0&id=39a7fdac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a7fdac"]])

export default __exports__